import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

function App() {
  const [content, setContent] = useState('');
  const [expirationHours, setExpirationHours] = useState(24);
  const [link, setLink] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/messages.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          content,
          expirationHours,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to create message');
      }

      setLink(`${window.location.origin}/view/${data.id}`);
      setContent('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(link);
      alert('Link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleCreateNew = () => {
    setLink('');
    setContent('');
    setError('');
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>ZeroTrace</h1>
        <p>Send encrypted messages that self-destruct after reading</p>
        
        {!link ? (
          <form onSubmit={handleSubmit} className="message-form">
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Enter your secret message..."
              required
            />
            
            <div className="expiration-container">
              <label>
                Message expires after:
                <select
                  value={expirationHours}
                  onChange={(e) => setExpirationHours(Number(e.target.value))}
                >
                  <option value="1">1 hour</option>
                  <option value="12">12 hours</option>
                  <option value="24">24 hours</option>
                  <option value="48">48 hours</option>
                  <option value="168">7 days</option>
                </select>
              </label>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? 'Creating...' : 'Create Message'}
            </button>
            
            <button 
              onClick={() => navigate('/donate')} 
              className="minimal-donate-button"
            >
              Support ZeroTrace &lt;3
            </button>
          </form>
        ) : (
          <div className="link-container">
            <p className="warning">Share this link with your recipient. The message will be deleted after being read!</p>
            <input type="text" value={link} readOnly />
            <div className="button-group">
              <button onClick={copyToClipboard}>Copy Link</button>
              <button onClick={handleCreateNew} className="new-message-button">Create New Message</button>
            </div>
          </div>
        )}

        {error && <p className="error">{error}</p>}
      </header>
    </div>
  );
}

export default App;
